import styled from 'styled-components';
import { Header } from 'components/common/fontElements';
import * as colors from 'components/common/colorConstants';

export const Wrapper = styled.main`
  height: 100%;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  background-color: ${colors.baseBackground};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
`;

export const Illustration = styled.img`
  width: 100px;
`;

export const HeaderText = styled(Header)`
  margin: 20px 0px 0px;
`;
